import { Option } from 'fp-ts/Option';
import { Container, Stack } from '@optimus-web/core';
import { Card, LocalizedModerateHighlight } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { BillType } from '@mews-commander/data-access';
import { CreditNoteCounterSelect } from '../reinstate/form/CreditNoteCounterSelect';
import { fieldNames } from './constants';

interface Props {
    billType: Option<BillType>;
}

export const CreditNoteCounterSection = ({ billType }: Props) => (
    <Container position="relative">
        <Card>
            <Stack spacing="300" vertical>
                <LocalizedModerateHighlight textKey={TextKey.CreditNoteCounter} />
                <CreditNoteCounterSelect
                    fieldName={fieldNames.creditNoteCounterId}
                    labelTextKey={TextKey.CounterName}
                    billType={billType}
                />
            </Stack>
        </Card>
    </Container>
);
